import { Outlet } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Container } from 'reactstrap';
import Header from './header/Header';
import Customizer from './customizer/Customizer';
import Sidebar from './sidebars/vertical/Sidebar';
import HorizontalHeader from './header/HorizontalHeader';
import HorizontalSidebar from './sidebars/horizontal/HorizontalSidebar';
import { AuthenticatedTemplate } from '@azure/msal-react';
import { fetchItems } from '../hooks/useFetchJson';
import { useAuth } from '../components/context/AuthContext';
import MaterialIcon from '@material/react-material-icon';
import { graphRequest } from '../../authConfig';
import { useMsal } from '@azure/msal-react';

const app_api_url = import.meta.env.VITE_APP_API_URL;

const FullLayout = () => {
  const { instance } = useMsal();
  const { accessToken, setPerfil } = useAuth();
  const user = JSON.parse(sessionStorage.getItem('user'));
  const [menuData, setMenuData] = useState([]);
  const [graphToken, setGraphToken] = useState(null);
  const [userPhoto, setUserPhoto] = useState(null);
  const customizerToggle = useSelector((state) => state.customizer.customizerSidebar);
  const toggleMiniSidebar = useSelector((state) => state.customizer.isMiniSidebar);
  const showMobileSidebar = useSelector((state) => state.customizer.isMobileSidebar);
  const topbarFixed = useSelector((state) => state.customizer.isTopbarFixed);
  const LayoutHorizontal = useSelector((state) => state.customizer.isLayoutHorizontal);
  const isFixedSidebar = useSelector((state) => state.customizer.isSidebarFixed);

  // Función para obtener el menú de la API
  const fetchMenuData = async () => {
    try {
      const responseData = await fetchItems(
        // `${app_api_url}/api/Menu/${user.username}/2`,
        `${app_api_url}/api/Menu/${user.username}/3`,
        accessToken,
      );

      console.log('Menu obtenido:', responseData.data);

      if (responseData && responseData.data && Array.isArray(responseData.data.menus)) {
        setPerfil(responseData.data.NombreRol);
        //console.log(responseData.data.NombreRol);
        const transformedData = responseData.data.menus.map((item) => ({
          title: item.title,
          href: item.href,
          icon: <MaterialIcon icon={item.icon || 'grid_view'} />,
          id: item.id,
          collapsible: item.collapsible === 1,
          children: Array.isArray(item.children)
            ? item.children.map((child) => ({
                title: child.title,
                href: child.href,
                icon: <MaterialIcon icon={child.icon || 'radio_button_checked'} />,
                id: child.id,
              }))
            : [],
        }));

        setMenuData(transformedData);
        setPerfil('Colaborador')
      } else {
        console.warn('No se encontraron menús del colaborador o la estructura es incorrecta.');
      }
    } catch (error) {
      console.error('Error al obtener menús del colaborador:', error.message || error);
    }
  };

  // Función para obtener el token para Microsoft Graph
  const getGraphToken = async () => {
    try {
      const response = await instance.acquireTokenSilent(graphRequest);
      setGraphToken(response.accessToken);
      return response.accessToken;
    } catch (error) {
      console.error('Error al obtener token para Microsoft Graph:', error);
      try {
        const response = await instance.acquireTokenPopup(graphRequest);
        setGraphToken(response.accessToken);
        return response.accessToken;
      } catch (popupError) {
        console.error('Error al obtener token mediante popup:', popupError);
        return null;
      }
    }
  };

  // Función para obtener la foto del usuario
  async function fetchUserPhoto(token) {
    try {
      const response = await fetch('https://graph.microsoft.com/v1.0/me/photo/$value', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error('Error al obtener la foto del usuario');
      }
      const blob = await response.blob();
      const photoUrl = URL.createObjectURL(blob);
      setUserPhoto(photoUrl);
      return photoUrl;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  useEffect(() => {
    fetchMenuData();
    (async () => {
      const token = await getGraphToken();
      if (token) {
        await fetchUserPhoto(token);
      }
    })();
  }, []); // Solo se ejecuta una vez al montar el componente

  return (
    <AuthenticatedTemplate>
      <main>
        <div
          className={`pageWrapper d-md-block d-lg-flex ${toggleMiniSidebar ? 'isMiniSidebar' : ''}`}
        >
          {/* Sidebar */}
          {LayoutHorizontal ? (
            ''
          ) : (
            <aside className={`sidebarArea ${showMobileSidebar ? 'showSidebar' : ''}`}>
              <Sidebar menuData={menuData} userPhoto={userPhoto} />
            </aside>
          )}

          {/* Área de contenido */}
          <div className={`contentArea ${topbarFixed ? 'fixedTopbar' : ''}`}>
            {LayoutHorizontal ? (
              <HorizontalHeader userPhoto={userPhoto} />
            ) : (
              <Header userPhoto={userPhoto} />
            )}
            {LayoutHorizontal ? (
              <HorizontalSidebar menuData={menuData} userPhoto={userPhoto} />
            ) : (
              ''
            )}
            <Container fluid className="p-4 boxContainer">
              <div className={isFixedSidebar && LayoutHorizontal ? 'HsidebarFixed' : ''}>
                <Outlet />
              </div>
              {/* Comento el Customizer para que no muestre el botón de engrane rojo en la app */}
              {/* <Customizer className={customizerToggle ? 'showCustomizer' : ''} /> */}
              {(showMobileSidebar || customizerToggle) && <div className="sidebarOverlay" />}
            </Container>
          </div>
        </div>
      </main>
    </AuthenticatedTemplate>
  );
};

export default FullLayout;
